import '../Inscription.less';
import { Form, Input, Button, Layout, Row, Col,Upload,notification, Modal, Checkbox, Select,ConfigProvider, Divider, Collapse,Menu,Spin, Popover } from 'antd';
import { HomeOutlined,UploadOutlined,CheckOutlined, PlusOutlined, MinusCircleOutlined} from '@ant-design/icons';
import React, { Component, Fragment } from "react";
import cabezal from '../Cabezal.jpg'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import es_ES from 'antd/lib/locale/es_ES';
import countries from '../../static/json/countries.json'
import {NavLink} from "react-router-dom";
import es from 'react-phone-input-2/lang/es.json'
import Foot from "../components/Footer"
import {IP,getCountryCode} from '../components/utils';
import UserMenu from "../components/UserMenu"

class Inscription extends Component {
  constructor(props){
    super(props)
    this.state={
      phone: '',
      sended: false,
      showRegistrate: false,
      genres:[],
      fileList: [],
      fileListAuth: [],
      authors:[],
      isBusy:false,
      genreSelected:false,
      portugueseGenre:false,
    }
  }

  async componentWillMount() {
    const plays = await fetch(IP + 'api/casa/obra/',{//this is to validate that is logued, since the award has already benn closed and it is necessary to be admin to register another conc
      method: "get",
      credentials: "same-origin",
      headers: {
        "Authorization": localStorage.getItem("Authorization") ,
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
    });
    const json_plays = await plays.json();
    if(json_plays['detail']){
      localStorage.clear()
      window.location.reload(); 
    }
    const response = await fetch(IP + 'api/casa/genero/');
    const json = await response.json();
    this.setState({ genres: json });
  }
  render() {
    const { Content } = Layout;
    const { Option } = Select;
    const { fileList,fileListAuth } = this.state;
    const { Panel } = Collapse;
    const formItemLayout = {
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 8,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
    };
    
    const validateMessages =  {
      required: '${label} es requerido!',
      types: {
        email: '${label} no es un email válido!',
        number: '${label} no es un número válido!',
      },
      number: {
        range: '${label} must be between ${min} and ${max}',
      },
    }

    const customRequest = (form) => {
      console.log("FORM",form)
     if(!form['pdf']){
      notification.error({
        message:'Error',
        description:'PDF de la obra es requerido',
      });
      return
     }
     if(form['pdf'].fileList[0]["originFileObj"].type != 'application/pdf'){
      notification.error({
        message:'Error',
        description:'La obra subida no es un PDF',
      });
      return
     }

    
      const data= new FormData()
      var autores =  JSON.parse(JSON.stringify(form['autores'])); 
      var pdf = JSON.parse(JSON.stringify(form['pdf'])); 
      form['pseudo'] = form['pseudo']? form['pseudo']:''

      for(var aut in  form['autores']){
        form['autores'][aut]['tel'] = '+' + form['autores'][aut]['tel']
        form['autores'][aut]['pais'] = getCountryCode(form['autores'][aut]['pais'])
      }
    
      form['pdf'] =  form['pdf'].fileList[0]["originFileObj"]
      

      for ( var key in form ) {
        if(key =='autores'){
          data.append(key,JSON.stringify( form[key]));
        }
        else{
          data.append(key, form[key]);
        }
    }
    data.append('premio',4)
    this.setState({isBusy:true},()=>axios.post(IP + 'api/casa/register/', data).then((res) => {
      if (res.status == 200){
        this.setState({isBusy:false})
        Modal.success({
          content: 'Gracias por registrarse en el concurso',
          onOk:()=> window.open("/casa/registro","_self")
        });
      } ;
    }).catch((err) => {
        this.setState({isBusy:false})
        form.autores =autores
        form.pdf = pdf
       
        notification.error({
          message:'Error',
          description:err.response.data.non_field_errors[0],
        });
      }))
  }
    const checkBoxChange = e =>{
      this.setState({showRegistrate:e.target.checked})
    }

    const uploadProps = {
      onRemove: file => {
        this.setState(state => {
          const index = this.state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState({
          fileList: [file],
        });
        return false;
      },
      fileList,
    };
    const uploadPropsAuth = {
      onRemove: file => {
        this.setState(state => {
          const index = this.state.fileListAuth.indexOf(file);
          const newFileList = state.fileListAuth.slice();
          newFileList.splice(index, 1);
          return {
            fileListAuth: newFileList,
          };
        });
      },
      beforeUpload: file => {
        this.setState({
          fileListAuth: [file],
        });
        return false;
      },
      fileListAuth,
    };
    return (
      <div className="page-container">
        <div className = "content-wrap">
          <ConfigProvider locale={es_ES}>
            <Layout style={{backgroundColor:'white'}}>
              <UserMenu/>
          
              <Row justify="start" align="middle">
                <Col span={24}>
                  <div style={{textAlign: 'center', fontWeight:'bold'}}> <Col span={24}><h1 className='title' style={{color:"black"}}>Inscripción</h1></Col></div>
                </Col>
              </Row>
              <Spin spinning={this.state.isBusy} >
                <Content>
                  <Row  justify="center" align="middle" >
                    <Col span={24}>
                      <Form {...formItemLayout} id='regForm' name="nest-messages" onFinish={customRequest} validateMessages={validateMessages} layout = 'horizontal' initialValues={{autores: [""]}}>
                        <Row  justify="center" align="middle" >
                          <Col xs={{span:24, offset:0 }}sm={{span:24, offset:0 }}>
                            <Divider style={{fontWeight:'bold', width:10, fontSize:'medium'}} >CONCURSANTE</Divider>
                            <Form.List name="autores">
                              {(fields, { add, remove }) => (
                              <>
                                {fields.map((field,index) =>( 
                                <>
                                  <Row  justify="center" align="left" >
                                    <Col xs={{span:24, offset:2}}sm={{span:10}}>
                                      <p >{fields.length==1?"Autor ": "Autor " + (index+1)} </p> 
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[field.name, 'nombre']} fieldKey={[field.fieldKey, 'first']} label="Nombre completo" rules={[{ required: true }]}>
                                        <Input style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                      
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[field.name,'pais']} label="País" fieldKey={[field.fieldKey, 's']} rules={[{ required: true }]}>
                                        <Select style={{width:'80%'}} showSearch className="my-select">
                                          {countries["countries"].sort((a,b)=>a["name_es"].localeCompare(b["name_es"])).map((obj)=>{
                                            return <Option value={obj["name_es"]}>{obj["name_es"]}</Option>
                                            })}
                                        </Select>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[field.name, 'email']} label="Correo electrónico" rules={[{ type: 'email',  required: true }]}>
                                        <Input style={{width:'80%'}} />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2}}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[ field.name,'tel']} label="Teléfono" rules={[{ required: true }]}>
                                        <PhoneInput
                                          localization={es}
                                          country={'cu'}
                                          enableSearch={true}
                                          searchPlaceholder="Buscar"
                                          value={this.state.phone}
                                          autoFocus= {true}
                                          onChange={phone => this.setState({ phone })}
                                          placeholder ={"Número de teléfono"}
                                        />
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[ field.name,'direccion']} label="Dirección postal"rules={[{ required: true }]}>
                                        <Input style={{width:'80%'}}/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                        
                                  <Row  justify="center" align="middle" >
                                    <Col xs={{span:24, offset:2 }}sm={{span:24, offset:0 }}>
                                      <Form.Item {...field} name={[ field.name,'ficha']} label="Ficha bio-bibliográfica"rules={[{ required: true }]}>
                                        <Input.TextArea  placeholder='Máximo 500 caracteres' style={{width:'80%'}} maxLength={500} showCount/>
                                      </Form.Item>
                                    </Col>
                                  </Row>
                                  {fields.length != index + 1 && <br/>}
                                  {fields.length== index + 1 && 
                                    <Row  justify="center" align="middle" >
                                      <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                                        <Form.Item >
                                          <Button type="dashed" onClick={() => add()}  icon={<PlusOutlined />}>
                                                Añadir autor
                                          </Button>
                                          { index >0 &&
                                            <Button type="dashed" onClick={() => remove(field.name)}  icon={<MinusCircleOutlined />}>
                                              Eliminar autor
                                            </Button> 
                                          }
                                        </Form.Item>
                                      </Col>
                                    </Row>}
                                  </>
                                ))}
                              </>
                            )}
                          </Form.List>
                        </Col>
                      </Row>
                      <Row  justify="center" align="middle" >
                        <Divider style={{fontWeight:'bold', fontSize:'medium'}} >OBRA</Divider>
                        <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                          <Form.Item name={['titulo']} label="Título de la obra"rules={[{ required: true, }]}>
                            <Input style={{width:'80%'}}/>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                          <Form.Item name={[ 'genero']} label="Género"rules={[{ required: true }]}>
                            <Select onChange={(value)=> this.setState({portugueseGenre:value == 'Literatura Brasileña (Ficción)', genreSelected:true})} style={{width:'80%'}}>
                            {this.state.genres.map((obj)=>{
                              if(obj.nombre != "Admin" && obj.activo)
                                return <Option value={obj.nombre}>{obj.nombre}</Option>
                              })}
                            </Select>
                          </Form.Item>
                        </Col>
                      </Row>
                       <Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:24, offset:0 }}>
                          <Form.Item name={[ 'pseudo']} rules={[{ required: !this.state.portugueseGenre }]} label="Seudónimo" >
                            <Input style={{width:'80%'}}/>
                          </Form.Item>
                        </Col>
                      </Row>
                      
                      {this.state.genreSelected && this.state.portugueseGenre && <Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                          
                          <Form.Item  name={['pdf']} >
                           
                              <Upload {...uploadProps}>
                              <Popover content='Debe subirse el pdf de la obra publicada, que incluya la página legal o de créditos'>
                                  <Button icon={<UploadOutlined  />}>Subir PDF de la obra</Button>
                          </Popover>

                              </Upload>
                          </Form.Item>
                        </Col>
                      </Row>
  }
  <Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                          <Form.Item  name={['pdf']} >
                           
                              <Upload {...uploadProps}>
                                  <Button icon={<UploadOutlined  />}>Subir PDF de la obra</Button>
                              </Upload>
                          </Form.Item>
                        </Col>
                      </Row>
   
                       {this.state.genreSelected &&<Row  justify="center" align="middle" >
                        <Col xs={{span:22, offset:2 }}sm={{span:16, offset:8 }}>
                          <Form.Item  >
                            <Checkbox onChange={checkBoxChange}>
                              Acepto los <NavLink to="/terminos" >Términos y condiciones de uso</NavLink>
                            </Checkbox><br/>
                            <br></br>
                            <Button icon={<CheckOutlined/>} type="primary" htmlType="submit" size='small' disabled={!this.state.showRegistrate}>
                              Registrarse
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
  }
                      
                    </Form>
                  </Col>
                </Row>
              </Content>
            </Spin>
          </Layout>
        </ConfigProvider>
    </div>
      <Foot/>
    </div>
    );
  }
}
export default Inscription;


